import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useInstanceId } from 'shared/src/hooks';
import { postAddress } from 'mypage/src/api/addressService';
import { queryKey } from '../../../constant/queryKey';

export const usePostAddress = () => {
  const client = useQueryClient();
  const instanceId = useInstanceId();
  return useMutation({
    mutationFn: postAddress,
    onSuccess: () => {
      client.invalidateQueries({ queryKey: queryKey.addresses(instanceId) });
    },
  });
};
